import { useForm, SubmitHandler, Controller } from "react-hook-form";
import useAxios from "axios-hooks";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  BusinessResDto,
  CreateBusinessDto,
  CreateBusinessSubscriptionDto,
} from "../../../api/Api";

import DatePicker from "react-datepicker";
import { useState } from "react";
import moment from "moment";

function getHumanReadableDateDiff(fromDate: string, toDate: string) {
  const start = moment(fromDate);
  const end = moment(toDate);

  const monthsDiff = end.diff(start, "months");
  // const yearsDiff = end.diff(start, "years");
  // const daysDiff = end.diff(start, "days");

  return `${monthsDiff} month${monthsDiff !== 1 ? "s" : ""}`;
}

export function BusinessSubscriptionForm(props: {
  defaultValues?: any;
  onFinish?: any;
}) {
  const params = useParams();
  const { state } = useLocation();

  const [startDate, setStartDate] = useState(
    moment(props?.defaultValues?.startDate).valueOf() as any
  );
  const [endDate, setEndDate] = useState(
    moment(props?.defaultValues?.endDate).valueOf() as any
  );

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<CreateBusinessSubscriptionDto>();

  const [{ loading, error }, createInfo] = useAxios<BusinessResDto, any>(
    {
      url: `/businesses/${params.businessId}`,
    },
    {
      manual: true,
    }
  );

  const onSubmit: SubmitHandler<CreateBusinessSubscriptionDto> = async (
    data
  ) => {
    try {
      const businessInfo = await createInfo({
        method: "PATCH",
        data: {
          subscription: {
            startDate: startDate,
            endDate: endDate,
            studentQuantity: parseInt(data.studentQuantity.toString()),
            status: data?.status,
          },
        },
      });
      props.onFinish(businessInfo?.data?.subscription);
    } catch (error) {}
  };

  return (
    <div className="">
      <form className="grid grid-cols-1  " onSubmit={handleSubmit(onSubmit)}>
        <label className="form-control w-full">
          <div className="label">
            <span className="label-text">Student Quantity</span>
          </div>
          <input
            defaultValue={props.defaultValues?.studentQuantity}
            disabled={loading}
            {...register("studentQuantity", {
              required: true,
            })}
            type="text"
            className="input input-bordered input-sm w-full"
          />
          <div className="label">
            {errors?.studentQuantity?.type === "required" && (
              <span className="label-text-alt text-error">
                This field is required
              </span>
            )}
          </div>
        </label>

        <div className="grid grid-cols-2 gap-2">
          <label className="form-control w-full">
            <div className="label">
              <span className="label-text">Valid From Date</span>
            </div>
            <DatePicker
              selected={startDate}
              className="bg-base-300 w-full"
              customInput={<input className="input input-sm "></input>}
              onChange={(date) =>
                setStartDate(moment(date).startOf("day").valueOf() as any)
              }
            />
            <div className="label">
              {errors?.validFrom?.type === "required" && (
                <span className="label-text-alt text-error">
                  This field is required
                </span>
              )}
            </div>
          </label>
          <label className="form-control w-full">
            <div className="label">
              <span className="label-text">Valid To Date</span>
            </div>
            <DatePicker
              selected={endDate}
              className="bg-base-300 w-full"
              customInput={<input className="input input-sm "></input>}
              onChange={(date) =>
                setEndDate(moment(date).startOf("day").valueOf() as any)
              }
            />
            <div className="label">
              {errors?.validTo?.type === "required" && (
                <span className="label-text-alt text-error">
                  This field is required
                </span>
              )}
            </div>
          </label>
        </div>

        <div className=" w-full">
          <div className="flex ">
            <div className="flex items-center">
              <div className="label">
                <span className="label-text">Duration:</span>
              </div>
              <div className="font-bold">
                {getHumanReadableDateDiff(
                  moment(startDate).format("YYYY-MM-DD"),
                  moment(endDate).format("YYYY-MM-DD")
                )}
              </div>
            </div>
            <div className="flex items-center ml-auto">
              <div className="label">
                <span className="label-text">
                  {moment(startDate).isAfter(moment())
                    ? "Starts in:"
                    : "Expires in:"}
                </span>
              </div>
              <div className="font-bold">
                {Math.floor(
                  moment
                    .duration(
                      moment(
                        moment(startDate).isAfter(moment())
                          ? startDate
                          : endDate
                      ).diff(moment())
                    )
                    .asDays()
                )}{" "}
                Days
              </div>
            </div>
          </div>
          <label className="form-control w-full">
            <div className="label">
              <span className="label-text">Status</span>
            </div>
            <select
              defaultValue={props.defaultValues?.status || ""}
              disabled={loading}
              {...register("status", {
                required: true,
              })}
              className="select select-bordered select-sm w-full"
            >
              <option value="" disabled>
                Select status
              </option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="pending">Pending</option>
            </select>
            <div className="label">
              {errors?.status?.type === "required" && (
                <span className="label-text-alt text-error">
                  This field is required
                </span>
              )}
            </div>
          </label>

          <button
            className="btn btn-sm  btn-primary mt-12 w-full"
            disabled={loading}
            type="submit"
          >
            Save
          </button>
        </div>
        {error && (
          <div className="alert alert-error text-sm mt-6 text-center">
            {error?.response?.data?.message}
            {error?.response?.data?.__type === "UserNotConfirmedException" && (
              <button
                onClick={(e) => {
                  e.preventDefault();
                }}
                className="btn btn-xs ml-auto"
              >
                Resend code
              </button>
            )}
          </div>
        )}
        {loading && (
          <div className="flex items-center justify-center mt-6">
            <div className="loading loading-spinner "></div>
          </div>
        )}
        {state?.confirmed && (
          <div className="alert alert-success text-sm mt-6 text-center">
            {state?.message}
          </div>
        )}
      </form>

      {/* <div className="flex flex-col gap-2 items-center">
        <AuthLink
          label="Sign Up"
          message="You dont have an account?"
          path="/auth/signup"
        ></AuthLink>
        <AuthLink
          label="Forgot Password"
          message="You forgot your password?"
          path="/auth/forgot-password"
        ></AuthLink>
      </div> */}
    </div>
  );
}
